<template lang="pug">
div.preview-element.text-element-preview(:style="wrapStyle")
	slot
</template>

<script>
import {computed} from "vue";
import {PreviewHelper} from "@/preview/PreviewHelper";

export default {
	name: "TextElementPreview",
	props: {
		spec: {
			type: Object,
			default() {
				return {}
			}
		},

		selectedItems: {
			type: Object,
			default() {
				return {}
			}
		},
		fontFamily: {
			type: Object,
			default() {
				return {}
			}
		},
		textColorForce: {
			type: String,
			default: ''
		}
	},

	setup(props) {

		const { textColor } = PreviewHelper(props);

		const wrapStyle = computed(() => {

			var font_family = '';
			if (props.fontFamily.family) {
				font_family = props.fontFamily.family;
			} else {
                font_family = props.fontFamily.value;
            }

			var textColorFinal = props.textColorForce ? props.textColorForce : textColor.value;
			return `
			height: ${props.spec.line_height * props.spec.max_text_lines }px;
			top: ${props.spec.top}%;
			left: ${props.spec.left}%;
			line-height: ${props.spec.line_height}px;
			font-size: ${props.spec.font_size}px;
			font-weight: ${props.spec.font_weight};
			font-family: ${font_family};
			color: ${textColorFinal};
		   	-webkit-line-clamp: ${props.spec.max_text_lines};
			z-index: 9;
			`;
		})

		return {
			wrapStyle,
			textColor
		}
	}
}
</script>

<style lang="scss">
    .text-content > div {
        align-items: center;
        align-content: center;
        justify-content: center;
        vertical-align: middle;
        .emoji {
            margin: 1px 0;
            vertical-align: sub;
        }
    }

	.preview-element {
		&.text-element-preview {
			position: absolute;
			text-align: center;
			text-overflow: unset;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-content: center;
			align-items: center;
			.text-content {
				position: relative;
				width: 100%;
			}

            .emoji {
                height: 1em;
            }
		}
	}
</style>
